import { fetchJSON } from '@bonnet/core/fetch';

import { cmApiUrl } from '@atc/cm-api-url';

export default (query = {}) => fetchJSON(
    cmApiUrl('/rest/lsc/listing/similar'),
    {
        circuitBreaker: {
            id: 'similarlistings',
            timeout: 3000,
            resetTimeout: 300000,
            fallback: {},
        },
        query,
        headers: {
            'X-fwd-svc': 'atc',
            'X-CoxAuto-Caller-Id': 'CI2355308',
        },
    }
);
